import { SimplePage } from "@/app/_/marketing/SimplePage";
import { SliceAndDiceFeature } from "@/app/_/sections/3FeaturesSection/SliceAndDiceFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="For founders"
      title="AI-assisted books without the bookkeeping tax."
      subtitle="Connect your accounts, let agents handle categorization and document matching, and pull investor-ready P&L, balance sheet, and cash flow reports when you need them."
      secondaryCta={{
        label: "Book a demo",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "reports-dashboard",
        alt: "An investor-ready dashboard",
      }}
      capabilities={[
        {
          title: "Monday: it's already categorized.",
          description:
            "Last week's card and bank activity arrives matched to receipts and categories. You skim and approve.",
          imageName: "crop-triage-suggestion",
        },
        {
          title: "Mid-month: see where it went.",
          description:
            "Open any charge to see its category, receipt, and the journal entry it posted to — no spreadsheet archaeology.",
          imageName: "crop-transaction-detail",
        },
        {
          title: "Board meeting: send a link.",
          description:
            "P&L, cash flow, and balances that stay live. Share the dashboard instead of exporting a spreadsheet.",
          imageName: "crop-report-widgets",
        },
      ]}
      illustration={{
        title: "Investor-ready, any day of the month.",
        description:
          "The numbers are always booked, so the report you'd build for a raise is the one you already have.",
        render: () => SliceAndDiceFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/reports", "/platform/agents"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
